import { render, staticRenderFns } from "./Repartidor.vue?vue&type=template&id=2085e364&"
import script from "./Repartidor.vue?vue&type=script&lang=js&"
export * from "./Repartidor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports